"use strict";

exports.__esModule = true;
exports.DsSgDatePicker = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@sg-bootstrap/components/dist/react-library/src/components");
var _moment = _interopRequireDefault(require("moment"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// @ts-nocheck

var DsSgDatePicker = exports.DsSgDatePicker = function DsSgDatePicker(_ref) {
  var id = _ref.id,
    onChange = _ref.onChange,
    displayFormat = _ref.displayFormat,
    placeholder = _ref.placeholder,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en-GB' : _ref$locale,
    initDate = _ref.initDate,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$enableYearSelect = _ref.enableYearSelectable,
    enableYearSelectable = _ref$enableYearSelect === void 0 ? true : _ref$enableYearSelect,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$isPastDateEnable = _ref.isPastDateEnabled,
    isPastDateEnabled = _ref$isPastDateEnable === void 0 ? true : _ref$isPastDateEnable;
  var handleDateChange = function handleDateChange(event) {
    if (onChange) {
      var date = (0, _moment["default"])(event.detail.timestamp);
      var dateStr = date.local().format('YYYY-MM-DD');
      onChange(dateStr);
    }
  };
  var handleInvalidValue = function handleInvalidValue() {
    if (onChange) {
      onChange(undefined);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SgDatepicker, {
    id: id,
    initialValue: initDate && (0, _moment["default"])(initDate).isValid() ? "" + (0, _moment["default"])(initDate).valueOf() : undefined,
    displayFormat: displayFormat,
    placeholder: placeholder,
    size: size,
    yearControllers: enableYearSelectable,
    locale: locale,
    onDateSelected: handleDateChange,
    onDateUnSelected: handleInvalidValue,
    onInputCleared: handleInvalidValue,
    onInvalidDate: handleInvalidValue,
    disabled: disabled,
    disablePresets: isPastDateEnabled ? '' : 'past'
  });
};